// Builds `${base}/${param}`, or just `base` when no param is given
const withParam = (base: string) => (param?: string) => (param ? `${base}/${encodeURIComponent(param)}` : base)

export const paths = {
    home: '/',
    collection: {
        root: '/collection',
        create: '/collection/create',
        update: withParam('/collection/update'),
        account: withParam('/collection/account'),
    },
    funding: {
        root: '/funding',
        create: '/funding/create',
        update: withParam('/funding/update'),
    },
    deduction: {
        root: '/deduction',
        create: '/deduction/create',
        update: withParam('/deduction/update'),
    },
    user: withParam('/user'),
    simplePayment: withParam('/simple_payment'),
}

// Top-level section of a pathname, e.g. '/collection/update/123' -> '/collection'
export const sectionRoot = (pathname: string) => '/' + pathname.split('/')[1]

export type EntityKind = 'collection' | 'collectionAccount' | 'funding' | 'deduction' | 'user' | 'simplePayment'

const entityPaths: Record<EntityKind, (id?: string) => string> = {
    collection: paths.collection.update,
    collectionAccount: paths.collection.account,
    funding: paths.funding.update,
    deduction: paths.deduction.update,
    user: paths.user,
    simplePayment: paths.simplePayment,
}

// Page where an entity of this kind can be looked up and updated
export const entityPath = (kind: EntityKind, id?: string) => entityPaths[kind](id)
